
import React, { useEffect, useRef, useState } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import './attachment.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt, faFilePdf, faPaperclip, faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { useTranslation } from 'react-i18next';


export default function Attachment({ attachments }) {
    const { t } = useTranslation();
    const op = useRef(null);
    const [products, setProducts] = useState(attachments);
    const [selectedProduct, setSelectedProduct] = useState();
    const [loading, setLoading] = useState(false);
    const [loadingItemId, setLoadingItemId] = useState(null);

    // Dosya indirme işlemini ayrı bir fonksiyon olarak tanımlayalım
    const downloadFile = (file) => {
        if (!file) return;
        
        // Yükleme durumunu başlat ve tıklanan öğenin ID'sini sakla
        setLoading(true);
        setLoadingItemId(file.id);

        // PDF indirme işlemi
        const link = document.createElement('a');
        link.href = file?.uri;
        link.download = file?.filename || 'downloaded.pdf'; // İndirilecek dosya adı
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Kısa bir gecikme sonrasında yükleme durumunu sıfırla
        setTimeout(() => {
            setLoading(false);
            setLoadingItemId(null);
        }, 2000);
    };

    useEffect(() => {
        if (selectedProduct) {
            downloadFile(selectedProduct);
        }
    }, [selectedProduct])

    // Dosya simgesini oluşturan yardımcı fonksiyon
    const fileIconTemplate = (rowData) => {
        // Dosya adı veya uzantısından PDF olup olmadığını kontrol et
        const isPdf = rowData.fileName?.toLowerCase().endsWith('.pdf') || 
                     rowData.fileType === 'pdf' || 
                     rowData.mimeType === 'application/pdf';
        
        return (
            <div className="file-item" onClick={(e) => {
                e.stopPropagation();
                // Doğrudan indirme fonksiyonunu çağıralım, böylece aynı öğeyi tekrar seçince de çalışacak
                downloadFile(rowData);
                // Seçimi yine de güncelleyelim
                setSelectedProduct(rowData);
            }}>
                {loading && loadingItemId === rowData.id ? (
                    <FontAwesomeIcon icon={faSpinner} className="file-icon spinner" spin />
                ) : (
                    <FontAwesomeIcon 
                        icon={isPdf ? faFilePdf : faFileAlt} 
                        className={`file-icon ${isPdf ? 'pdf-icon' : ''}`} 
                    />
                )}
                <span className="file-name">
                    {loading && loadingItemId === rowData.id ? 
                        t('pleaceWait') : 
                        isPdf ? rowData.fileName.replace(/\.pdf$/i, '') : rowData.fileName}
                </span>
            </div>
        );
    };
    
    return (
        <>
            <Button 
                className="attachment-icon-btn"
                icon={<FontAwesomeIcon icon={faPaperclip} />}
                rounded 
                text 
                tooltip={t('news.attachments')}
                tooltipOptions={{ position: 'top', className: 'attachment-tooltip' }}
                onClick={(e) => {
                    // Tıklama olayının üst öğelere yayılmasını engelle
                    e.stopPropagation();
                    op.current.toggle(e);
                }} 
            />
            <OverlayPanel ref={op} onClick={(e) => e.stopPropagation()} className="attachment-panel">
                <div className="attachment-title">
                    <FontAwesomeIcon icon={faPaperclip} className="attachment-header-icon" />
                    <span>{t('news.attachments')}</span>
                </div>
                <DataTable 
                    value={products} 
                    size='small'
                    className="attachment-table"
                >
                    <Column body={fileIconTemplate} header={t('news.fileName')} style={{ minWidth: '15rem' }} />
                </DataTable>
            </OverlayPanel>
        </>
    );
}
